import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal } from "antd";
import { apiUrl } from '../../utility/Connections';
import TableRelationshipsLinks from "../tableRelationshipsLinks/tableRelationshipsLinks";
import LoadingOverlay from "../loadingOverlay/loadingOverlay";

// Este componente recibe evl_id como prop
const ModalEvaluationLinks = ({ visible, onClose, evl_id }) => {
    const [loading, setLoading] = useState(false);
    const [relationships, setRelationships] = useState([]);
    const [evlTitle, setEvlTitle] = useState(null);
    const [pagination, setPagination] = useState({ page: 1, pageSize: 20, total: 0 });

    const getEvaluationRelationshipsLinks = (page = 1, pageSize = 20) => {
        setLoading(true);
        const token = localStorage.getItem('access_token');
        const headers = { headers: { 'Authorization': `Bearer ${token}` } };
        const url = `${apiUrl}/evaluation-relationships/get-evaluation-relationships-links/${evl_id}/?page=${page}&page_size=${pageSize}`;

        axios.get(url, headers)
            .then(function (response) {
                const data = response.data.employees;
                const title = response.data.title;
                const pager = response.data.pagination;
                setRelationships(data);
                setEvlTitle(title);
                if (pager) {
                    setPagination({
                        page: pager.page,
                        pageSize: pager.page_size,
                        total: pager.total,
                    });
                }
                setLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setLoading(false);
            });
    }

    useEffect(() => {
        if (visible && evl_id) {
            getEvaluationRelationshipsLinks();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible, evl_id]);

    const refreshTable = () => {
        getEvaluationRelationshipsLinks(1, pagination.pageSize || 20);
    }

    const handlePageChange = (page, pageSize) => {
        getEvaluationRelationshipsLinks(page, pageSize || pagination.pageSize || 20);
    }

    return (
        <Modal
            title={`ENLACES ${evlTitle ? evlTitle.toUpperCase() : "EVALUACIÓN"}`}
            open={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            width="95%"
            maskClosable={false}
        >
            {loading && <LoadingOverlay text="Cargando enlaces..." />}
            <TableRelationshipsLinks
                evl_relationships={relationships}
                evl_id={evl_id}
                evl_title={evlTitle}
                refreshTable={refreshTable}
                pagination={pagination}
                onPageChange={handlePageChange}
            />
        </Modal>
    );
};

export default ModalEvaluationLinks;
